/** Host identities are minted by the Everhall API's signed room token. */
export function isTeacher(identity: string | undefined): boolean {
  return Boolean(identity && /^Teacher:/.test(identity))
}
